import React from "react";
import { Link } from "react-router-dom";
import { Check, Star, ArrowRight } from "lucide-react";
import { loanTypes, images } from "../mock";
import PageHero from "../components/PageHero";
import VACalculator from "../components/VACalculator";
import { Button } from "../components/ui/button";
import { LenderCard } from "../components/Lender";

const LoanTypes = () => {
  return (
    <div>
      <PageHero
        eyebrow="For Veterans & VA Buyers"
        title="Putting Heroes into Homes"
        subtitle="From VA to USDA — the right loan is the one that gets you home. Here's how each one works."
        image={images.heroExteriors[1]}
      />

      <section className="max-w-7xl mx-auto px-6 md:px-8 py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {loanTypes.map((loan) => (
            <div
              key={loan.name}
              className={`rounded-3xl p-9 border hover-lift ${
                loan.highlight
                  ? "bg-[#141210] border-[#141210] text-[#e9dcc4]"
                  : "bg-white border-[#efe6d6]"
              }`}
            >
              <div className="flex items-center justify-between gap-3 mb-4">
                <h3
                  className={`font-display text-3xl ${
                    loan.highlight ? "text-[#f4ebd9]" : "text-[#141210]"
                  }`}
                >
                  {loan.name}
                </h3>
                {loan.highlight && (
                  <span className="flex items-center gap-1.5 bg-[#d4af37] text-white text-[10px] tracking-luxury uppercase px-3 py-1.5 rounded-full shrink-0">
                    <Star className="w-3 h-3 fill-white" /> My Specialty
                  </span>
                )}
                {loan.badge && !loan.highlight && (
                  <span className="flex items-center gap-1.5 bg-[#d4af37] text-white text-[10px] tracking-luxury uppercase px-3 py-1.5 rounded-full shrink-0">
                    <Star className="w-3 h-3 fill-white" /> {loan.badge}
                  </span>
                )}
              </div>
              <p
                className={`text-sm italic mb-6 ${
                  loan.highlight ? "text-[#c4b294]" : "text-gold"
                }`}
              >
                {loan.tagline}
              </p>
              <p
                className={`leading-relaxed mb-7 ${
                  loan.highlight ? "text-[#cabb9f]" : "text-[#5c5348]"
                }`}
              >
                {loan.description}
              </p>
              <ul className="space-y-3">
                {loan.perks.map((perk) => (
                  <li key={perk} className="flex items-start gap-3">
                    <span
                      className={`mt-0.5 w-5 h-5 rounded-full flex items-center justify-center shrink-0 ${
                        loan.highlight ? "bg-[#d4af37]" : "bg-[#f7edcf]"
                      }`}
                    >
                      <Check
                        className={`w-3 h-3 ${loan.highlight ? "text-white" : "text-gold"}`}
                      />
                    </span>
                    <span
                      className={`text-sm ${
                        loan.highlight ? "text-[#e9dcc4]" : "text-[#4a423a]"
                      }`}
                    >
                      {perk}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-8 pb-4 -mt-8">
        <LenderCard dark />
      </section>

      <section className="bg-[#f4f1ea]">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-24">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <span className="text-xs tracking-luxury uppercase text-gold">Run the Numbers</span>
            <h2 className="font-display text-4xl md:text-5xl text-[#141210] mt-4">
              VA Loan Calculator
            </h2>
          </div>
          <VACalculator />
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 md:px-8 py-24 text-center">
        <h2 className="font-display text-4xl md:text-5xl text-[#141210] mb-6">
          Not sure which loan fits you?
        </h2>
        <p className="text-[#5c5348] mb-9 max-w-xl mx-auto leading-relaxed">
          That's exactly what I'm here for. Let's talk through your situation and I'll connect you
          with my flexible lender for a no-pressure review.
        </p>
        <Link to="/apply-to-buy">
          <Button className="bg-[#d4af37] hover:bg-[#c19a2e] text-white rounded-full px-9 h-13 py-6 tracking-luxury uppercase text-xs">
            Apply to Buy <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </Link>
      </section>
    </div>
  );
};

export default LoanTypes;
